import { render, staticRenderFns } from "./MeetingsItems.vue?vue&type=template&id=1dc65be2&scoped=true"
import script from "./MeetingsItems.vue?vue&type=script&lang=js"
export * from "./MeetingsItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc65be2",
  null
  
)

export default component.exports